import api from './api';
import {PaginatedApi} from '../../components/organisms/CustomTable';
import {API_URL} from './api';
import {useGet} from './useGet';

const auditApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query<any, any>({
      query: (query) => `audit-logs?${typeof query === 'string' ? query : ''}`,
      providesTags: (result) => {
        return result?.auditLogs
          ? [...result.auditLogs?.map(({id}) => ({type: 'AuditLogs', id})), {type: 'AuditLogs', id: 'LIST'}]
          : [{type: 'AuditLogs', id: 'LIST'}];
      },
    }),
    getAuditLogUsers: builder.query<any, void>({
      query: () => `audit-logs/users`,
      providesTags: [{type: 'AuditLogs', id: 'USERS'}],
    }),
    getAuditStats: builder.query<any, {startDate: string; endDate: string}>({
      query: ({startDate, endDate}) => `audit-logs/stats?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      providesTags: [{type: 'AuditLogs', id: 'STATS'}],
    }),
  }),
});

export const useGetAuditLogs = (filter): PaginatedApi<any> => {
  const get = useGet();
  return async (page, pageSize, sort, searchString) => {
    const take = pageSize || 100;
    const skip = page * pageSize || 0;
    const selectedSort = sort && Array.isArray(sort) && sort.length > 0 ? sort[0] : null;
    const orderBy = selectedSort?.id || 'createdAt';
    const desc = selectedSort?.desc ? 'DESC' : 'ASC';
    const searchParam = searchString && searchString.trim() ? `&search=${encodeURIComponent(searchString.trim())}` : '';
    const response = await get(
      `${API_URL}/audit-logs?${filter}&take=${take}&skip=${skip}${orderBy ? `&orderBy=${orderBy}&desc=${desc}` : ''}${searchParam}`,
    );
    const json = await response.json();
    const {auditLogs, total} = json;
    return {
      results: auditLogs || [],
      pageCount: Math.ceil(total / pageSize),
      total: total || 0,
    };
  };
};

export const {useGetAuditLogsQuery, useGetAuditLogUsersQuery, useGetAuditStatsQuery} = auditApi;
